import { Offer } from '../types';
import { KeyboardEvent } from 'react';
import { REGISTERED_APPS } from '../shared/types/Apps';
import { getIntelligemsVariantPrice } from '../shared/product-page-placement/intelligemsUtils';
import { calculateDiscountedPrice } from '../shared/utils/discounts';

export function convertPresentmentCurrency(
  amount: number,
  amount_type?: string,
) {
  if (amount < 0) return 0;

  if (amount_type === 'fixed_amount') {
    return amount * Number(window.Shopify.currency.rate);
  }
  return amount;
}

const handleConfirmation = (cb: any) => (e: KeyboardEvent<HTMLDivElement>) => {
  if (e.key === 'Enter') {
    cb && cb();
  }
};

function getDiscountedPrice(
  offer: Partial<Offer>,
  variant: any,
  quantity: number,
  isIntelligemsEnabled: boolean,
  app?: REGISTERED_APPS,
) {
  const { amount_type, amount, apply_discount } = offer;

  const intelligemsPriceForVariant = getIntelligemsVariantPrice(
    isIntelligemsEnabled,
    variant?.id,
    variant?.title,
  );
  // we know the intelligemsPriceForVariant exists, as the variant.price fallback is defined at this point
  const variantPrice =
    ((intelligemsPriceForVariant ?? variant.price) * quantity) / 100;

  return calculateDiscountedPrice(
    variantPrice,
    convertPresentmentCurrency(Number(amount), amount_type),
    amount_type,
    apply_discount,
    app,
  );
}

export { getDiscountedPrice, handleConfirmation };
